module.exports = __webpack_public_path__ + "img/xm02-7da5d4.png";